import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Filter, ChevronDown } from 'lucide-react';

export default function ReportFilters({ filters, setFilters, hospitals, showFilters, setShowFilters, onApply, onReset }) {
  return (
    <div className="bg-white border-b shadow-sm print:hidden">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between mb-3">
          <button
            onClick={() => setShowFilters(!showFilters)}
            className="flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
            data-testid="reports-toggle-filters"
          >
            <Filter className="w-4 h-4" />
            Filters
            <ChevronDown className={`w-4 h-4 transition-transform ${showFilters ? 'rotate-180' : ''}`} />
          </button>
          {showFilters && (
            <div className="flex gap-2">
              <Button size="sm" onClick={onApply} className="bg-blue-600 hover:bg-blue-700" data-testid="reports-apply-filters">
                Apply Filters
              </Button>
              <Button size="sm" variant="outline" onClick={onReset} data-testid="reports-reset-filters">
                Reset
              </Button>
            </div>
          )}
        </div>

        {showFilters && (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
            <div>
              <label className="text-xs text-gray-500 mb-1 block">From Date</label>
              <Input
                type="date"
                value={filters.dateFrom}
                onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
                className="h-9 text-sm"
                data-testid="reports-filter-date-from"
              />
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">To Date</label>
              <Input
                type="date"
                value={filters.dateTo}
                onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
                className="h-9 text-sm"
                data-testid="reports-filter-date-to"
              />
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">Hospital</label>
              <Select value={filters.hospital} onValueChange={(v) => setFilters({ ...filters, hospital: v })}>
                <SelectTrigger className="h-9 text-sm" data-testid="reports-filter-hospital">
                  <SelectValue placeholder="All Hospitals" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Hospitals</SelectItem>
                  {hospitals.map(h => (
                    <SelectItem key={h.hospital_name} value={h.hospital_name}>
                      {h.hospital_name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">Member</label>
              <Input
                placeholder="Search member..."
                value={filters.member}
                onChange={(e) => setFilters({ ...filters, member: e.target.value })}
                className="h-9 text-sm"
                data-testid="reports-filter-member"
              />
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">Policy/Family ID</label>
              <Input
                placeholder="Search policy..."
                value={filters.policy}
                onChange={(e) => setFilters({ ...filters, policy: e.target.value })}
                className="h-9 text-sm"
                data-testid="reports-filter-policy"
              />
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">Status</label>
              <Select value={filters.status} onValueChange={(v) => setFilters({ ...filters, status: v })}>
                <SelectTrigger className="h-9 text-sm" data-testid="reports-filter-status">
                  <SelectValue placeholder="All Status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Status</SelectItem>
                  <SelectItem value="PENDING">Pending</SelectItem>
                  <SelectItem value="PAID">Approved/Paid</SelectItem>
                  <SelectItem value="REJECTED">Rejected</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">Currency</label>
              <Select value={filters.currency} onValueChange={(v) => setFilters({ ...filters, currency: v })}>
                <SelectTrigger className="h-9 text-sm" data-testid="reports-filter-currency">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="USD">USD</SelectItem>
                  <SelectItem value="SSP">SSP</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
